import css from "styled-jsx/css";

export const componentStyles = css.global`
  .badges-grid-mobile-component {
    .badge-wrapper {
      padding: 8px;
    }

    .slick-list {
      padding: 0 20% 0;

      .slick-track {
        .slick-slide {
          .picture-component {
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
      }
    }
  }
`;
